// extracted by mini-css-extract-plugin
export default {"widget":"CyberSportFavoriteEvents_widget--QWy","live":"CyberSportFavoriteEvents_live--lOQ","userLoader":"CyberSportFavoriteEvents_userLoader--EIu"};